import { useState } from "react";
import { Box, Typography, Paper, Button, Alert } from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { runOpeningLayersMigration } from "../../../services/accounting";

export default function AccountingMigrationsPage() {
  useProtectedRoute();
  const { token, user } = useAuth() as any;
  const tenantId = user?.tenantId || user?.tenant?.id;
  const [report, setReport] = useState<any>(null);
  const [running, setRunning] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const run = async (dryRun: boolean) => {
    if (!tenantId) return;
    setRunning(true);
    try {
      const res = await runOpeningLayersMigration(token!, tenantId, dryRun);
      setReport(res);
      setMessage(dryRun ? "Dry run complete" : "Migration complete");
      setTimeout(()=>setMessage(null), 2000);
    } catch (e) { console.error(e); }
    finally { setRunning(false); }
  };

  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight="bold" className="mb-4">Accounting Tools - Migrations</Typography>
      {message && <Alert severity="success" className="mb-3">{message}</Alert>}
      <Paper className="p-4 mb-4">
        <Typography className="mb-2">Opening Inventory to Cost Layers</Typography>
        <div className="flex gap-2">
          <Button variant="outlined" disabled={running} onClick={()=>run(true)}>Dry Run</Button>
          <Button variant="contained" disabled={running} onClick={()=>run(false)}>Run Migration</Button>
        </div>
      </Paper>
      {report && (
        <Paper className="p-4">
          <Typography variant="subtitle1" className="mb-2">Items processed: {report.count}</Typography>
          <div className="max-h-96 overflow-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left">
                  <th>ItemId</th>
                  <th>Qty</th>
                  <th>Unit Cost</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                {(report.items || []).map((r:any, idx:number)=> (
                  <tr key={idx}>
                    <td>{r.itemId}</td>
                    <td>{r.qty}</td>
                    <td>{r.unitCost}</td>
                    <td>{r.created ? 'Yes' : 'No'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Paper>
      )}
    </Box>
  );
}
